import React, { Component } from 'react';
import styled from 'styled-components';
import { getTheme, screen } from '../../global/utils';
import BreadcrumbItem from './BreadcrumbItem';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome } from '@fortawesome/free-solid-svg-icons';

const Crumb = styled.nav`
  font-size: ${getTheme('fontSize', 'note')};
  ul {
    list-style: none;
    margin: 0;
    padding-left: ${getTheme('spacer', 'm')};
    display: flex;
  }

  @media (max-width: ${screen('sMax')}) {
    display: none;
  }
`;

class Breadcrumb extends Component {
  render() {
    return (
      <Crumb>
        <ul>
          <BreadcrumbItem text="Home" url="/" icon={<FontAwesomeIcon icon={faHome} />} />
          <BreadcrumbItem text="Projects" url="/projects" />
          <li>{this.props.project}</li>
        </ul>
      </Crumb>
    );
  }
}

export default Breadcrumb;



// WEBPACK FOOTER //
// ./src/components/navs/Breadcrumb.js